// How long an appointment booked from the task panel runs.
//
// A service has one length for the practice; a provider may override it for
// their own pairing (a consultation with Dr. Levitan runs 90 minutes, the
// service says 60). The override wins, then the service, then whatever the
// grid said about the slot, then 30.
export interface MinutesMapping {
  /** The pairing's own override, in minutes; null or absent means none. */
  duration?: number | null;
  service: { duration?: number | null; [key: string]: unknown };
}

export function bookableMinutes(
  slot: { duration?: number | null },
  mapping: MinutesMapping | null | undefined,
): number {
  return Number(mapping?.duration) || Number(mapping?.service?.duration) || Number(slot?.duration) || 30;
}
